import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

export type Language = "en" | "fr";
export const frenchCatalog: Record<string, string> = fr;

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: navigator.language.toLowerCase().startsWith("fr") ? "fr" : "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLanguage(language: Language) {
  document.documentElement.lang = language;
  return i18n.changeLanguage(language);
}

export const t = i18n.t.bind(i18n);
document.documentElement.lang = i18n.resolvedLanguage?.startsWith("fr")
  ? "fr"
  : "en";
export default i18n;
